import Image from 'next/image';
import React from 'react'
import loader from "../../public/assets/loading.gif"

const Loader = () => {
  return (
    <div className='h-[400px] flex items-center justify-center'>
      <Image src={loader} alt="loading..." width={200} height={200} />
    </div>
    // <div className={`flex justify-center items-center h-[300px] font-medium text-orange animate__animated  ${padding.py}`}>Loading <span className="loading-animated"></span></div>
  )
}

export default Loader